


























































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import {
  NoteModel,
  DistributorsClient,
  NotesClient,
} from "@/diamond-support-api";
import { Action } from "vuex-class";
import RemoveItemDialog from "@/components/app/RemoveItemDialog.vue";
import { ErrorMessage, SuccessMessage } from "@/shared";

@Component({
  components: {
    RemoveItemDialog
  },
})
export default class NoteList extends Vue {
    @Action("showMessage", { namespace: "notification" }) showMessage: any;
  notes: NoteModel[] = [];
  notesApi = new NotesClient();
  distributorNoteApi = new DistributorsClient();

  shown = true;
  search = "";
  sortBy = "isCritical";
  isDescending = true;
  loadingTable = false;

  removeItem: NoteModel | null = null;
  removeMessage = "";
  showRemoveDialog = false;

  headers: any[] = [
    {
      text: "Urgent ",
      value: "isCritical",
      sortable: false,
    },
    {
      text: "CreatedBy",
      value: "createdBy",
    },
    {
      text: "Content",
      value: "content",
      width: "30%",
    },
    {
      text: "Created time",
      value: "createdUtc",
      sortable: true,
    },
    {
      text: "Edit",
      align: "center",
      sortable: false,
      value: "edit",
    },
    {
      text: "Delete",
      align: "center",
      sortable: false,
      value: "delete",
    },
  ];

  async mounted() {
    this.loadingTable = true;
    this.notes = await this.distributorNoteApi.getNotes(this.$route.params.id);
    this.loadingTable = false;
  }

  editNote(noteId: string) {
    this.$router.push({
      path: `/associates/${this.$route.params.id}/detail/notesList/${noteId}/noteEdit`,
    });
  }

  noteUpdated(note: NoteModel) {
    let index = this.notes!.map(function (x) {
      return x.id;
    }).indexOf(note.id);
    if (index >= 0) this.notes!.splice(index, 1, note);
  }

  removeNote(note: NoteModel) {
    this.removeItem = note;
    this.removeMessage = `Are you sure you want to remove the note ?`;
    this.showRemoveDialog = true;
  }

    noteRemoved(note: NoteModel) {
    let index = this.notes!.map(function (x) {
      return x.id;
    }).indexOf(note.id);
    if (index >= 0) this.notes!.splice(index, 1);
  }

    async confirmRemove() {
    if (this.removeItem) {
      await this.notesApi
        .delete(this.removeItem.id)
        .then((response) => {
          if (response !== null) this.noteRemoved(this.removeItem!);
          this.showMessage(new SuccessMessage(`Note has been deleted.`));
        })
        .catch((error) => {
          console.log(error);
          this.showMessage(new ErrorMessage(`An error occured: \r\n${error}`));
        });
    }
    this.showRemoveDialog = false;
  }

  @Watch("shown")
  onShownChanged() {
    if (!this.shown)
      this.$router.push(`/associates/${this.$route.params.id}/detail`);
  }
}
